import { Box, Stack, Typography, Button, Chip, Select, MenuItem } from "@mui/material";
import React, { useState } from "react";
import { Drawer, TextField } from "@mui/material";
import { Tooltip } from "@mui/material";

const InventoryGrid = ({
  room,
  daysOfMonth,
  startIndex,
  daysPerPage,
  selectedDays,
  setSelectedDays,
  editType,
  setEditType,
  editModeRoom,
  setEditModeRoom,
  isSelecting,
  setIsSelecting,
  selectionStart,
  setSelectionStart,
  editRatePlan,
  setEditRatePlan,
  bulkDrawer,
  setBulkDrawer,
  bulkValue,
  setBulkValue,
  bulkAdjustmentType,
  setBulkAdjustmentType,
  handleApplyBulk

}) => {
const labelStyle = {
  backgroundColor: "#F8FAFC",
  borderRight: "1px solid #E2E8F0",
  borderBottom: "1px solid #E2E8F0",
  px: 2,
  py: 2,
  fontWeight: 600,
  fontSize: 14,

  display: "flex",
  alignItems: "center",
  cursor:"pointer",

  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

const cellStyle = {
  borderLeft: "1px solid #E2E8F0",
  borderBottom: "1px solid #E2E8F0",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: 48,
  fontSize: 14,
  transition: "all 0.15s ease",
  "&:hover": {
  backgroundColor: "#EEF2FF",
  
}
};
const ratePlansMap = new Map();
const parseDate = (dateStr) => {
    const [y, m, d] = dateStr.split("-");
    return new Date(y, m - 1, d);
  };

room.days.forEach(day => {
  day.rates?.forEach(rate => {
    if (rate.ratePlanId) {
      ratePlansMap.set(rate.ratePlanId, rate.name);
    }
  });
});

const extraRatePlans = Array.from(ratePlansMap.entries()).map(([id, name]) => ({
  id,
  name
}));
 const hasPrice = room.days?.some(day =>
  day.rates?.some(rate => rate.price > 0)
);


  return (
  <Box
    sx={{
      border: "1px solid #E2E8F0",
      borderRadius: 3,
      overflow: "hidden",
      mb: 5,
    }}
  >
    {/* ROOM HEADER */}
   
    <Box
      sx={{
        backgroundColor: "#F8FAFC",
        px: 3,
        py: 2,
        borderBottom: "1px solid #E2E8F0",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
      }}
    >
      <Typography fontWeight={600}>
        {room.title}
      </Typography>

      {!hasPrice && (
        <Chip
          label="Prix non défini"
          size="small"
          onClick={() => {
            setBulkDrawer({
              open: true,
              type: "base",
              roomId: room.roomId
            });
            setBulkValue(100)
          }}
          sx={{
            backgroundColor: "#FEF3C7",
            color: "#92400E",
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "#FDE68A"
            }
          }}
        />
      )}
    </Box>

        {/* GRID */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: `180px repeat(${daysPerPage}, 1fr)`,
            userSelect: "none",
      }}
    >
      {/* ================= TARIF ROW ================= */}
      <Box sx={labelStyle} onClick={() => {
        setBulkDrawer({
          open: true,
          type: "base",
          roomId: room.roomId
        });
        setBulkValue(room.price);
      }}>Prix initial (€)</Box>

      {/* ✅ STANDARD (editable) */}
      {daysOfMonth
        .slice(startIndex, startIndex + daysPerPage)
        .map((dateStr, index) => {
          const dayData = room.days[startIndex + index]

          const rates = dayData?.rates || []
          const standardRate = rates.find(r => r.ratePlanId === null)
          const price = standardRate?.price ?? room.price

          const isSelected =
            (selectedDays[editType] || []).includes(index) &&
            editType === "tarif" &&
            editModeRoom === room.roomId &&
            editRatePlan === null; // 🔥 IMPORTANT

          const isFirst =
            isSelected &&
            !((selectedDays[editType] || []).includes(index - 1));

          const isLast =
            isSelected &&
            !((selectedDays[editType] || []).includes(index + 1));

          return (
            <Box
              key={index}
              onMouseDown={() => {
                

                setIsSelecting(true);
                setSelectionStart(index);
                setEditModeRoom(room.roomId);
                setEditType("tarif");
                setEditRatePlan(null)

                setSelectedDays({
                  tarif: [index],
                  inventory: [],
                  status: [],
                });
              }}
              onMouseEnter={() => {
                if (
                  isSelecting &&
                  editType === "tarif" &&
                  editModeRoom === room.roomId &&
                  selectionStart !== null
                ) {
                  const start = Math.min(selectionStart, index);
                  const end = Math.max(selectionStart, index);

                  const range = [];
                  for (let i = start; i <= end; i++) {
                    range.push(i);
                  }

                  setSelectedDays({
                    tarif: range,
                    inventory: [],
                    status: [],
                  });
                }
              }}
              onMouseUp={() => {
                setIsSelecting(false);
                setSelectionStart(null);
              }}
              sx={{
                ...cellStyle,
                cursor: "pointer",
                backgroundColor:
                  isSelected
                    ? "#4F46E5"
                    : price === 0
                    ? "#FEE2E2"
                    : "#FFFFFF",
                color: isSelected ? "white" : "inherit",
                borderTopLeftRadius: isFirst ? 8 : 0,
                borderBottomLeftRadius: isFirst ? 8 : 0,
                borderTopRightRadius: isLast ? 8 : 0,
                borderBottomRightRadius: isLast ? 8 : 0,
              }}
            >
              {price}
            </Box>
          );
          
        })}

      {/* 🔒 AUTRES TARIFS */}
      {extraRatePlans.map(plan => (
  <React.Fragment key={plan.id}>
    <Tooltip title={plan.name}>
    <Box sx={{ ...labelStyle }}>
  
  <Box  onClick={() => {
        setBulkDrawer({
          open: true,
          type: "rateplan",
          ratePlan: plan
        });

        setBulkAdjustmentType(plan.adjustmentType || "fixed");
        setBulkValue(plan.adjustmentValue || "");
      }} sx={{
    fontWeight: 600,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }}>
    {plan.name}
  </Box>
</Box> </Tooltip>

    {daysOfMonth
      .slice(startIndex, startIndex + daysPerPage)
      .map((dateStr, index) => {

        const dayData = room.days[startIndex + index]
        const date = parseDate(dateStr)
        const dayOfWeek = date.getDay()

        const applies =
          !plan.daysOfWeek ||
          plan.daysOfWeek.length === 0 ||
          plan.daysOfWeek.includes(dayOfWeek)

        const rate = dayData?.rates?.find(r => r.ratePlanId === plan.id)
        const price = rate?.price ?? "-"

        const isSelected =
          selectedDays.tarif.includes(index) &&
          editType === "tarif" &&
          editModeRoom === room.roomId &&
          editRatePlan === plan.id

        return (
          <Box
            key={index}
            onMouseDown={() => {

              if (!applies) return;

              setIsSelecting(true);
              setSelectionStart(index);
              setEditModeRoom(room.roomId);
              setEditType("tarif");
              setEditRatePlan(plan.id); // 🔥 IMPORTANT

              setSelectedDays({
                tarif: [index],
                inventory: [],
                status: [],
              });

            }}
            onMouseEnter={() => {
              if (
                isSelecting &&
                editType === "tarif" &&
                editModeRoom === room.roomId &&
                editRatePlan === plan.id &&
                selectionStart !== null
              ) {
                const start = Math.min(selectionStart, index);
                const end = Math.max(selectionStart, index);

                const range = [];
                for (let i = start; i <= end; i++) {
                  range.push(i);
                }

                setSelectedDays({
                  tarif: range,
                  inventory: [],
                  status: [],
                });
              }
            }}
            onMouseUp={() => {
              setIsSelecting(false);
              setSelectionStart(null);
            }}
            sx={{
              ...cellStyle,
              cursor: applies ? "pointer" : "not-allowed",
              backgroundColor:
                !applies
                  ? "#F1F5F9"
                  : isSelected
                  ? "#4F46E5"
                  : "#FFFFFF",
              color: isSelected ? "white" : "inherit",
            }}
          >
            {applies ? price : "—"}
          </Box>
        );
      })}
  </React.Fragment>
))}


      {/* ================= STOCK ROW ================= */}
      <Box
        sx={labelStyle}
        onClick={() => {
          setBulkDrawer({
            open: true,
            type: "inventory",
            roomId: room.roomId
          });

          setBulkValue(""); // ou valeur actuelle si tu veux
        }}
      >
        Stock
      </Box>

      {daysOfMonth
        .slice(startIndex, startIndex + daysPerPage)
        .map((dateStr, index) => {
          const dayData = room.days[startIndex + index]

          const available = dayData?.inventory ?? 0
          const isSelected = (selectedDays[editType] || []).includes(index);

          const isFirst =
            isSelected &&
            !((selectedDays[editType] || []).includes(index - 1));

          const isLast =
            isSelected &&
            !((selectedDays[editType] || []).includes(index + 1));

          return (
            <Box
              key={index}
              onMouseDown={() => {
                setIsSelecting(true);
                setSelectionStart(index);
                setEditModeRoom(room.roomId);
                setEditType("inventory");

                setSelectedDays({
                  tarif: [],
                  inventory: [index],
                  status: [],
                });
              }}
              onMouseEnter={() => {
                if (
                  isSelecting &&
                  editType === "inventory" &&
                  editModeRoom === room.roomId &&
                  selectionStart !== null
                ) {
                  const start = Math.min(selectionStart, index);
                  const end = Math.max(selectionStart, index);

                  const range = [];
                  for (let i = start; i <= end; i++) {
                    range.push(i);
                  }

                  setSelectedDays({
                    tarif: [],
                    inventory: range,
                    status: [],
                  });
                }
              }}
              onMouseUp={() => {
                setIsSelecting(false);
                setSelectionStart(null);
              }}
              sx={{
                ...cellStyle,
                cursor: "pointer",
                backgroundColor:
                  selectedDays.inventory.includes(index) &&
                  editType === "inventory" &&
                  editModeRoom === room.roomId
                    ? "#4F46E5"
                    : available === 0
                    ? "#FEE2E2"
                    : "#FFFFFF",
                color:
                  selectedDays.inventory.includes(index) &&
                  editType === "inventory" &&
                  editModeRoom === room.roomId
                    ? "white"
                    : "inherit",
                borderTopLeftRadius: isFirst ? 8 : 0,
                borderBottomLeftRadius: isFirst ? 8 : 0,
                borderTopRightRadius: isLast ? 8 : 0,
                borderBottomRightRadius: isLast ? 8 : 0,
              }}
            >
              {available}
            </Box>
          );
        })}

      {/* ================= STATUS ROW ================= */}
      <Box sx={labelStyle}>Statut</Box>

      {daysOfMonth
        .slice(startIndex, startIndex + daysPerPage)
        .map((dateStr, index) => {
          const dayData = room.days[startIndex + index]

          const status = dayData?.status ?? "opened"
          const isClosed = status === "closed";
          const isSelected = (selectedDays[editType] || []).includes(index);

          const isFirst =
            isSelected &&
            !((selectedDays[editType] || []).includes(index - 1));

          const isLast =
            isSelected &&
            !((selectedDays[editType] || []).includes(index + 1));

          return (
            <Box
              key={index}
              onMouseDown={() => {
                setIsSelecting(true);
                setSelectionStart(index);
                setEditModeRoom(room.roomId);
                setEditType("status");

                setSelectedDays({
                  tarif: [],
                  inventory: [],
                  status: [index],
                });
              }}
              onMouseEnter={() => {
                if (
                  isSelecting &&
                  editType === "status" &&
                  editModeRoom === room.roomId &&
                  selectionStart !== null
                ) {
                  const start = Math.min(selectionStart, index);
                  const end = Math.max(selectionStart, index);

                  const range = [];
                  for (let i = start; i <= end; i++) {
                    range.push(i);
                  }

                  setSelectedDays({
                    tarif: [],
                    inventory: [],
                    status: range,
                  });
                }
              }}
              onMouseUp={() => {
                setIsSelecting(false);
                setSelectionStart(null);
              }}
              sx={{
                ...cellStyle,
                cursor: "pointer",
                fontWeight: 600,
                backgroundColor:
                  selectedDays.status.includes(index) &&
                  editType === "status" &&
                  editModeRoom === room.roomId
                    ? "#4F46E5"
                    : isClosed
                    ? "#F1F5F9"
                    : "#DCFCE7",
                color:
                  selectedDays.status.includes(index) &&
                  editType === "status" &&
                  editModeRoom === room.roomId
                    ? "white"
                    : isClosed
                    ? "#475569"
                    : "#166534",
                borderTopLeftRadius: isFirst ? 8 : 0,
                borderBottomLeftRadius: isFirst ? 8 : 0,
                borderTopRightRadius: isLast ? 8 : 0,
                borderBottomRightRadius: isLast ? 8 : 0,
              }}
            >
              {isClosed ? "F" : "O"}
            </Box>
          );
        })}
    </Box>
   <Drawer
  anchor="right"
  open={bulkDrawer.open}
  onClose={() => setBulkDrawer({ open: false })}
  PaperProps={{
    sx: {
      width: 380,
      borderTopLeftRadius: 16,
      borderBottomLeftRadius: 16,
    }
  }}
>
  <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>

    {/* 🔥 HEADER */}
    <Box sx={{ p: 3, borderBottom: "1px solid #E2E8F0" }}>
      <Typography variant="h6" fontWeight={600}>
        {bulkDrawer.type === "base" && "Prix de base"}
        {bulkDrawer.type === "inventory" && "Stock"}
        {bulkDrawer.type === "rateplan" && bulkDrawer.ratePlan?.name}
      </Typography>

      <Typography variant="body2" color="text.secondary">
        Modifier en masse sur la période affichée
      </Typography>
    </Box>

    {/* 🔥 CONTENT */}
    <Box sx={{ flex: 1, p: 3, display: "flex", flexDirection: "column", gap: 2 }}>

      {/* INPUT */}
      <TextField
        fullWidth
        type="number"
        label={
          bulkDrawer.type === "inventory"
            ? "Stock"
            : "Valeur"
        }
        value={bulkValue}
        onChange={(e) => setBulkValue(e.target.value)}
      />

      {/* TYPE (RATEPLAN ONLY) */}
      {bulkDrawer.type === "rateplan" && (
        <TextField
          select
          fullWidth
          label="Type d'ajustement"
          value={bulkAdjustmentType}
          onChange={(e) => setBulkAdjustmentType(e.target.value)}
        >
          <MenuItem value="fixed">Montant (€)</MenuItem>
          <MenuItem value="percentage">Pourcentage (%)</MenuItem>
        </TextField>
      )}

      {/* 💡 PREVIEW */}
      <Box
        sx={{
          mt: 1,
          p: 2,
          borderRadius: 2,
          backgroundColor: "#F8FAFC",
          border: "1px solid #E2E8F0"
        }}
      >
        <Typography variant="body2" color="text.secondary">
          Aperçu
        </Typography>

        <Typography fontWeight={600}>
          {bulkDrawer.type === "base" && `Prix de base : ${bulkValue || 0} €`}

          {bulkDrawer.type === "inventory" &&
            `Stock : ${bulkValue || 0} chambre(s)`}

          {bulkDrawer.type === "rateplan" &&
            (bulkAdjustmentType === "percentage"
              ? `+${bulkValue || 0}% sur le prix`
              : `+${bulkValue || 0} € sur le prix`)
          }
        </Typography>
      </Box>

    </Box>

    {/* 🔥 FOOTER */}
    <Box
      sx={{
        p: 3,
        borderTop: "1px solid #E2E8F0",
        display: "flex",
        gap: 2
      }}
    >
      <Button
        fullWidth
        variant="outlined"
        onClick={() => setBulkDrawer({ open: false })}
      >
        Annuler
      </Button>

      <Button
        fullWidth
        variant="contained"
        disabled={!bulkValue}
        onClick={handleApplyBulk}
      >
        Appliquer
      </Button>
    </Box>

  </Box>
</Drawer>
  </Box>
);
};

export default InventoryGrid;